import { Injectable, Inject } from '@angular/core';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';

@Injectable({ providedIn: 'root' })
export class MaterialSearchTermsService {
  public dataLength = 0;
  public selectedData;
  currentSavedOptions;

  private optionSaver = {
    searchTerms: {},
    pageNumber: 0,
    pageSize: 0,
    pageMode: '4 Columns'
  };

  constructor(
    @Inject(LOCAL_STORAGE) private storage: StorageService
  ) {
    this.currentSavedOptions = this.optionSaver;
  }

  saveSearchTermsInLocal(key, val): void {
    let currentlyStoredTableOptions = null;
    const unparsedStorageObject = this.storage.get(key);

    if (unparsedStorageObject && unparsedStorageObject !== undefined) currentlyStoredTableOptions = JSON.parse(unparsedStorageObject);

    if (currentlyStoredTableOptions) this.currentSavedOptions = currentlyStoredTableOptions;
    else this.currentSavedOptions = this.optionSaver;

    this.currentSavedOptions.searchTerms = val;
    this.storage.set(key, JSON.stringify(this.currentSavedOptions));
  }


  getSearchTermsFromLocal(key) {
    let termsFound = null;

    if (this.storage.get(key)) {
      const currentSavedOptions = JSON.parse(this.storage.get(key));
      if (currentSavedOptions && currentSavedOptions.searchTerms) termsFound = currentSavedOptions.searchTerms;
    }
    return termsFound;
  }


  saveTableOptionsInLocal(key, pageNumber, pageSize, pageMode) {
    const termsFromStorage = this.storage.get(key);
    const currentlyStoredTableOptions = termsFromStorage ? JSON.parse(this.storage.get(key)) : null;

    if (currentlyStoredTableOptions) this.currentSavedOptions = currentlyStoredTableOptions
    else this.currentSavedOptions = this.optionSaver;

    this.currentSavedOptions.pageNumber = pageNumber;
    this.currentSavedOptions.pageSize = pageSize;
    this.currentSavedOptions.pageMode = pageMode;

    this.storage.set(key, JSON.stringify(this.currentSavedOptions));
  }


  getTableOptionsFromLocal(key) {
    if (this.storage.get(key)) this.currentSavedOptions = JSON.parse(this.storage.get(key));
    return this.currentSavedOptions;
  }


  saveAdditionalOptionsInLocal(key: string, additional: { sort?: string; selectedCategoriesMulti?: string[] }) {
    const raw = this.storage.get(key);
    const current = raw ? JSON.parse(raw) : { ...this.optionSaver };
    if (additional.sort !== undefined) current.sort = additional.sort;
    if (additional.selectedCategoriesMulti !== undefined) current.selectedCategoriesMulti = additional.selectedCategoriesMulti;
    this.storage.set(key, JSON.stringify(current));
  }


  getAdditionalOptionsFromLocal(key: string): { sort?: string; selectedCategoriesMulti?: string[] } {
    const raw = this.storage.get(key);
    if (!raw) return {};
    const stored = JSON.parse(raw);
    return {
      sort: stored?.sort,
      selectedCategoriesMulti: stored?.selectedCategoriesMulti
    };
  }
}